var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SelectGroup,_vm._b({staticClass:"w-full",attrs:{"id":_vm.data.id,"placeholder":_vm.data.placeholder,"value":_setup.resolvedValue,"required":_vm.data.required,"readonly":_vm.data.readonly,"options":_vm.data.options},on:{"update":_setup.setValue}},'select-group',_setup.attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }